module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-main-absolute"
  }, [_c('div', {
    staticClass: "flex-box"
  }, [_c('div', {
    ref: "swipe",
    staticClass: "flex-item-1 toucharea "
  }, [_vm._v("\n      Swipe\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-box"
  }, [_c('div', {
    ref: "swipeUp",
    staticClass: "flex-item-1 toucharea"
  }, [_vm._v("\n      Swipe Up\n    ")]), _vm._v(" "), _c('div', {
    ref: "swipeDown",
    staticClass: "flex-item-1 toucharea"
  }, [_vm._v("\n      Swipe Down\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-box"
  }, [_c('div', {
    ref: "swipeLeft",
    staticClass: "flex-item-1 toucharea "
  }, [_vm._v("\n      Swipe Left\n    ")]), _vm._v(" "), _c('div', {
    ref: "swipeRight",
    staticClass: "flex-item-1 toucharea"
  }, [_vm._v("\n      Swipe Right\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-box"
  }, [_c('div', {
    ref: "swipeX",
    staticClass: "flex-item-1 toucharea "
  }, [_vm._v("\n      Swipe X\n    ")]), _vm._v(" "), _c('div', {
    ref: "swipeY",
    staticClass: "flex-item-1 toucharea"
  }, [_vm._v("\n      Swipe Y\n    ")])]), _vm._v(" "), _c('toast', {
    ref: "success",
    attrs: {
      "type": "success",
      "content": _vm.content
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f679ecde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/touch/demo.vue
// module id = 283
// module chunks = 33